/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import ReportQueryContainer from './ReportQuery'
import { withPropsOnChange } from 'recompose'

const SumerianContainer = withPropsOnChange(
  ['currentConfig', 'currentLocation', 'currentSeason'],
  origProps => {
    const { data } = origProps
    const sumerianData = Object.values(data.locations).map(loc => {
      const { location, coordinates, ratings, labelOffset } = loc

      return {
        location,
        coordinates,
        ratings,
        labelOffset,
      }
    })
    return {
      sumerianUrl: data.app.sumerianUrl,
      sumerianData,
      sumerian: data.sumerian,
    }
  }
)

export default SumerianContainer
